import React from 'react';

const Item = (props) => (
  <li className="item cfix">
    <span className="name">{props.name}</span>
    <div className="products-number">{props.numberOfProducts}</div>
    <div className="action-btn">
      <button className="btn-edit" onClick={props.onEdit}>
        {props.editBtnText}
      </button>
      <button className="btn-delete" onClick={props.onDelete}>
        {props.deleteBtnText}
      </button>
    </div>
  </li>
);

export default Item;
